module.exports = __webpack_public_path__ + "media/images/iconBell__inFrontOfAccent-0adf25506735427715dfaa7b0f744089.png";